module.exports = __webpack_public_path__ + "static/media/Jackpot.f1548b64.mp3";